<template>
  <v-app dark style="background-color: #efefef">
    <div>
      <v-img max-height="70" src="/images/ipl-bg.png"> </v-img>
      <v-toolbar>
        <v-card flat style="margin-top: -60px">
          <img @click="openHome" src="../../assets/ipl-logo.png" style="cursor:pointer;" width="170px" />
        </v-card>
        <v-toolbar-title class="ml-4"><h3>{{$store.state.pageTitle}}</h3></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn outlined color="error" @click="openReports"
          ><v-icon left>mdi-finance</v-icon> Reports</v-btn
        >
        <v-btn outlined class="ml-2" color="error" @click="openNewApplication"
          ><v-icon left>mdi-plus-thick</v-icon> New Application</v-btn
        >
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              v-bind="attrs"
              v-on="on"
              class="ml-2"
              color="error"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="(item, i) in menuitems" :key="i">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </div>
    <v-main>
      <div class="pa-2">
        <router-view></router-view>
      </div>
    </v-main>
    <v-footer :absolute="!fixed" app>
      <span>&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        { icon: "mdi-apps", text: "Dashboard", to: "/admin" },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Masters",
          model: false,
          children: [
            { icon: "mdi-plus", text: "Card Master", to: "/admin/cards" },
            { icon: "mdi-plus", text: "Venue Master", to: "/admin/venues" },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Reports",
          model: false,
          children: [
            { icon: "mdi-plus", text: "Report 1", to: "/admin/cards" },
          ],
        },
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      menuitems: [
        { title: "Profile" },
        { title: "Change Password" },
        { title: "Logout" },
      ],
    };
  },
  methods: {
    openNewApplication: function () {
      this.$router.push("../app/newapplication").catch(() => {});
    },
    openReports: function () {
      this.$router.push("../app/reports").catch(() => {});
    },
    openHome: function () {
      this.$router.push("../app").catch(() => {});
    },
  },
};
</script>
